import { useQuery } from "react-query";
import { getManageableList } from "../api";
import { API_KEY_GET_MANAGEABLE_LIST } from "../constants";

export const useGetManageableList = () => {
  return useQuery([API_KEY_GET_MANAGEABLE_LIST], () => getManageableList());
};
